import moment from "moment";
export class StaffSkillCerts {
  StaffID;
  SkillCate;
  Item;
  Seq;
  Ans;
  DateFrom;
  DateTo;
  AddBy;
  ModifyBy;
  constructor() {
    this.StaffID = "";
    this.SkillCate = "";
    this.Item = "";
    this.Seq = "";
    this.Ans = "";
    this.DateFrom = moment().format("YYYY-MM-DD");
    this.DateTo = moment().format("YYYY-MM-DD");
    this.AddBy = "";
    this.ModifyBy = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/StaffSkillCerts.js